import { render, staticRenderFns } from "./tabs-file.vue?vue&type=template&id=646a60b9"
import script from "./tabs-file.vue?vue&type=script&lang=js"
export * from "./tabs-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports